import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ProductContributorAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('artist');
  }
}
